import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import FilmCard from "@/components/base/FilmCard";
import FilmCardSkeleton from "@/components/base/FilmCardSkeleton";
import { latestFilms } from "@/lib/film";
import { useDemoLoading } from "@/hooks/useDemoLoading";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "./components/HeroCarousel";
import GenreEntry from "./components/GenreEntry";
import HotSection from "./components/HotSection";
import TopicPreview from "./components/TopicPreview";
import IntroSection from "./components/IntroSection";

export default function Home() {
  const loading = useDemoLoading(300);
  const latest = latestFilms(8);

  usePageMeta({
    title: "日本一级片 - 最新日本一级影视影片资源平台",
    description:
      "日本一级片网站专注提供丰富的日本一级影视内容，包括最新影片资讯和详细介绍，满足用户对高品质影视资源的需求。",
    keywords: "日本一级片,日本一级影片,日本影视,日本电影,日本一级影视资源",
  });

  return (
    <SiteLayout>
      <HeroCarousel />
      <GenreEntry />

      <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6 md:mb-8">
          <div>
            <p className="text-[11px] tracking-[0.24em] text-primary-600 uppercase mb-2 font-label">LATEST RELEASES</p>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950">最新影片</h2>
            <p className="mt-2 text-sm text-foreground-600">按上映时间倒序更新，优先呈现近期值得关注的作品。</p>
          </div>
          <Link
            to="/category?sort=latest"
            className="inline-flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部影片
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            {Array.from({ length: 8 }).map((_, index) => (
              <FilmCardSkeleton key={index} />
            ))}
          </div>
        ) : latest.length === 0 ? (
          <p className="text-sm text-foreground-600">暂无影片更新</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            {latest.map((film) => (
              <FilmCard key={film.id} film={film} />
            ))}
          </div>
        )}
      </section>

      <HotSection loading={loading} />
      <TopicPreview />
      <IntroSection />
    </SiteLayout>
  );
}